<template>
  <d-container fluid class="main-content-container px-4">
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('numerex.create.subtitle') }}
        </span>
        <h3 class="page-title">{{ $t('numerex.create.title') }}</h3>
      </d-col>
    </d-row>

    <numerex-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import { MODEL } from '../components/NumerexModel';
import NumerexPage from '../components/NumerexPage.vue';

export default {
  name: 'numerex-create',
  components: {
    NumerexPage,
  },
  methods: {
    ...mapActions(['setNumerex']),
  },
  created() {
    Events.$emit('sidebarVisible', false);
    this.setNumerex(cloneDeep(MODEL));
  },
};
</script>
